import React from "react";
import styles from "./CharacterCount.module.css";

export const CharacterCount = ({ value, max, className }) => {
  const length = (value || "").length;

  return (
    <span className={[styles.charCount, className].filter(Boolean).join(" ")}>
      {length}/{max}
    </span>
  );
};
